<template>
  <div class="hello">
    <hr width="60%"/>
    <hr width="40%"/>
    <hr width="20%"/>
    <h1>{{ msg }}</h1>
    <hr width="20%"/>
    <hr width="40%"/>
    <hr width="60%"/>
    <h3>{{ task }}</h3>
    <h3>{{ topictext }} {{ topic }}</h3>
    <p> 
      <input type="text" v-model="topic"
	     id="theme"
	     v-show="showInput"
             placeholder="Dein Thema?"
	     v-on:blur="finishInput()" />
    </p>
    <div v-for="i in 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z'.split(' ')">
        {{ i }} <input type="text"
		       name="buchstabe"
		       v-model="answers[i]"
		       class="buchstabe"
		       placeholder="???">
    </div>	
    <button v-on:click="printlocal()">Sende an lokalen Drucker und wähle dann als Druckausgabe <b>PDF</b></button>
  </div>
</template>

<script>
export default {
  name: 'abclist',
  data () {
    return {
      msg: 'ABC-Liste',
      task: 'Finde für jeden Buchstaben im Alphabet einen Begriff! ',
      topictext: 'Das Thema lautet: ',
      topic: '',
      showInput: true,
      answers: {}
    }
  },
  methods: {
    printlocal: function () {
      window.print()
    },
    finishInput: function () {
      this.showInput = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buchstabe {
  width: 400px;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// ABCList.vue?4c8e4f08